export const freePlan = {
    title: 'free',
    features: ['Live chat with guests', 'Check guests in/out', 'Track ticket status', 'Up to 5 users'],
    price: '£0 /mo',
    buttonText: 'Switch to Free',
}

export const plusPlan = {
    title: 'plus',
    features: ['Live chat with guests', 'Check guests in/out', 'Track ticket status', 'Up to 15 users'],
    price: '£59 /mo',
    buttonText: 'Switch to Plus',
}

export const proPlan = {
    title: 'pro',
    features: ['Live chat with guests', 'Check guests in/out', 'Track ticket status', 'Unilimited users'],
    price: '£119 /mo',
    buttonText: 'Switch to Pro',
}

export const planIds = {
    free: 'plan_F16WlQMwT3HKCi',
    plus: 'plan_Ezd8eGcARtKvjs',
    pro: 'plan_EzdACF4lzado30',
}
